import { render } from "./ClienteLayout.vue?vue&type=template&id=73186779&scoped=true"
import script from "./ClienteLayout.vue?vue&type=script&lang=js"
export * from "./ClienteLayout.vue?vue&type=script&lang=js"

import "./ClienteLayout.vue?vue&type=style&index=0&id=73186779&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73186779"]])

export default __exports__